import cyberactivity1 from "../../../assets/CampuLifeImages/cyberactivityq.jpg"
import cyberactivity2 from "../../../assets/CampuLifeImages/cyberactivity2.jpg"
import cyberactivity3 from "../../../assets/CampuLifeImages/cyberactivity3.jpg"
import cyberactivity4 from "../../../assets/CampuLifeImages/cyberactivity4.jpg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage';
import cyberbanner from "../../../assets/CampuLifeImages/cyberbanner.jpg"

const CyberCrime = () => {
   const womenCellContent = {
    name:"cybercrime",
    contentImg:cyberbanner,
    title:"Cyber Crime Awareness Committee Activities",
    pagename:"Cyber Crime Awareness" ,
    viewmore:"true",
    hover:true,
    viewless:"true",
    para:"The Cyber Crime Awareness Club seeks to educate and empower students on the importance of online safety and the prevention of cyber crimes. To enhance cybercrime awareness among students, emphasize good online habits, including strong passwords, privacy settings, and recognizing suspicious emails or links, and encourage reporting cyberbullying or suspicious activity to trusted adults. ",
    paratitle:"Objectives of the Committee:",
    paratitlecontents:[{title:"Raising Awareness : ",content:"Informing students about various cyber threats like hacking, identity theft, and online scams."},
      {title:"Promoting Cyber Hygiene : ",content:"Teaching best practices for securing personal data, protecting privacy, and using the internet safely."},
      {title:"Organizing Events : ",content:"Hosting workshops, seminars, and campaigns to enhance understanding of cyber crime laws and safety measures."},
      {title:"Fostering Responsible Online Behavior : ",content:"Encouraging ethical conduct and respect for privacy in the digital world."},
      {title:"Providing Support : ",content:" Assisting victims of cyber crimes with resources and guidance for reporting and resolving issues."}
    ],
    subtitle2:"Through these efforts, we aim to create a well-informed and secure campus community.",
    fourhover:true
  }
  const hoverContent = [
    {img:cyberactivity1 , para1:"STOP CYBER BULLYING",para2:"October 12, 2023"},
    {img:cyberactivity2 , para1:"STOP CYBER BULLYING",para2:"October 12, 2023"},
    {img:cyberactivity3, para1:"PROTECTIVE MEASURES ON CYBER CRIME",para2:"July 12, 2024"},
    {img:cyberactivity4 , para1:"PROTECTIVE MEASURES ON CYBER CRIME",para2:"July 12, 2024"}
  ]

  const tableData = [
            {title:"Cyber Crime Awareness Member"},
            {headings:[{heading1:"S.No.",heading2:"Name",heading4:"Position"}]},
            {data:[{ id: 1, name: 'Dr. S. Kala',pos:"Convenor"},
            { id: 2, name: 'Mrs. J. Akila' ,pos:"Member"},
            {id: 3,name: "Mrs. P. Indira" ,pos:"Member"},
            {id: 4,name: "Mr. V. S. Krishna Prasad" ,pos:"Member"},
            {id: 5,name: "Mr. V. I. Sree Dev" ,pos:"Member"},
            {id: 6,name: "Mr. S. Meschac Raj" ,pos:"Member"},
          ]},
          {padding:true}
          ];
  return (
   <>
      <ExtenStudClubGrievPage data={womenCellContent} hoverContent={hoverContent} tableData={tableData}/>
   </>
  )
}

export default CyberCrime